import React from 'react';
import { batteryToText } from 'utils/utils';
import statusConverter from 'utils/statusConverter';

export const columnSetter = (moduleScn, flag) => {
  const columns = [
    {
      Header: 'No',
      accessor: 'rnum',
    },
    {
      Header: '설비번호',
      accessor: 'areaNo',
    },
    {
      Header: '설비명',
      accessor: 'areaNm',
    },
    {
      Header: '감지기No.',
      accessor: 'modelNm',
    },
    {
      Header: (
        <span>
          H<sub>2</sub>(%)
        </span>
      ),
      accessor: 'h2',
    },
    {
      Header: <span>CO(ppm)</span>,
      accessor: 'co',
    },
    {
      Header: (
        //() => flag === "0" ? <span>CH4(%)</span> : <span>CH4(%)</span>,
        <span>
          {flag === "0" ? <>CH<sub>4</sub>(%)</> : <>CH4(%)</>}
        </span>
      ),
      accessor: 'ch4',
    },
    {
      Header: (
        <span>
          CO<sub>2</sub>(%)
        </span>
      ),
      accessor: 'co2',
    },
    {
      id: 'status',
      Header: () => <div>상태</div>,
      Cell: ({ row }) => statusConverter(row.original.status, row.original.statusCode),
    },
    {
      id: 'Battery',
      Header: () => <div>Battery(%)</div>,
      Cell: ({ row }) => batteryToText(row.original.battery),
    },
    {
      Header: '측정시간',
      accessor: 'regDate',
    },
  ];

  return columns;
};
